<template>
  <span>
    <template v-for="(masterEmploymentStatus) in masterEmploymentStatuses">
      <img
        v-if="isContainEmploymentStatus(masterEmploymentStatus.id)"
        :key="masterEmploymentStatus.id"
        :src="`${userOfferImageUrlForSp}/${masterEmploymentStatus.iconName}`"
        :alt="masterEmploymentStatus.name"
        :data-test="`employment-${masterEmploymentStatus.id}`"
      >
    </template>
  </span>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/search/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import * as definition from '@/lib/labelValueMappings'

export default {
  mixins: [jobPreviewCommon],
  props: {
    employmentStatus: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      masterEmploymentStatuses: definition.employmentStatuses
    }
  }
}
</script>
